import { styled } from "../../config/stiches.config";

export const variantColorProps = {
  primary: {
    backgroundColor: "$colors$teal600",
    ["&:hover"]: {
      backgroundColor: "$colors$teal700",
    },
    ["&:focus"]: {
      boxShadow: "$colors$teal400 0px 0px 0px 3px",
    },
  },
  secondary: {
    backgroundColor: "$colors$magenta600",
    ["&:hover"]: {
      backgroundColor: "$colors$magenta700",
    },
    ["&:focus"]: {
      boxShadow: "$colors$magenta400 0px 0px 0px 3px",
    },
    ["&:disabled"]: {
      backgroundColor: "$colors$magenta700",
      color: "White",
      ["&:hover"]: {
        backgroundColor: "$colors$magenta700",
        color: "White",
      },
    },
  },
  light: {
    color: "$colors$teal700",
    backgroundColor: "$colors$teal50",
    stroke: "$colors$teal700",
    ["&:hover"]: {
      backgroundColor: "$colors$teal100",
    },
    ["&:focus"]: {
      boxShadow: "$colors$teal400 0px 0px 0px 3px",
    },
  },
  tealSubtle: {
    color: "$colors$teal700",
    backgroundColor: "$colors$teal100",
    stroke: "$colors$teal700",
    ["&:hover"]: {
      backgroundColor: "$colors$teal200",
    },
    ["&:focus"]: {
      boxShadow: "$colors$teal300 0px 0px 0px 3px",
    },
  },
  white: {
    color: "$colors$gray900",
    backgroundColor: "white",
    border: "1px solid $colors$gray300",
    ["&:hover"]: {
      backgroundColor: "$colors$gray50",
    },
    ["&:focus"]: {
      boxShadow: "$colors$gray200 0px 0px 0px 3px",
    },
  },
  text: {
    color: "$colors$teal600",
    py: "2px",
    px: "2px",
    backgroundColor: "transparent",
    maxHeight: "none",
    ["&:hover"]: {
      color: "$colors$teal800",
      backgroundColor: "transparent",
    },
    ["&:focus"]: {
      boxShadow: "none",
    },
  },
  textOnly: {
    color: "$colors$teal600",
    py: "2px",
    px: "2px",
    backgroundColor: "transparent",
    maxHeight: "none",
    boxShadow: "unset",
    borderRadius: "none",
    ["&:hover"]: {
      color: "$colors$teal600",
      boxShadow: "unset",
    },
    ["&:focus"]: {
      boxShadow: "unset",
    },
    ["&:disabled"]: {
      backgroundColor: "transparent",
    },
  },
  transparentText: {
    color: "$colors$gray900",
    py: "$space$4",
    backgroundColor: "transparent",
    borderStyle: "dashed",
    borderColor: "$colors$gray300",
    maxHeight: "none",
    boxShadow: "unset",
    ["&:hover"]: {
      color: "$colors$teal700",
    },
    ["&:focus"]: {
      boxShadow: "unset",
    },
    ["&:disabled"]: {
      backgroundColor: "transparent",
    },
  },
  textHoverable: {
    color: "$colors$gray500",
    py: "$space$2",
    px: "$space$3",
    backgroundColor: "transparent",
    maxHeight: "none",
    ["&:hover"]: {
      backgroundColor: "white",
    },
    ["&:focus"]: {
      backgroundColor: "white",
      boxShadow: "$colors$teal400 0px 0px 0px 3px",
    },
    ["&:active"]: {
      backgroundColor: "white",
      boxShadow: "$colors$teal400 0px 0px 0px 3px",
    },
  },
  textOnlyDark: {
    color: "$colors$gray800",
    py: "2px",
    px: "2px",
    backgroundColor: "transparent",
    maxHeight: "none",
    boxShadow: "unset",
    borderRadius: "none",
    ["&:hover"]: {
      color: "$colors$gray600",
      boxShadow: "unset",
    },
    ["&:focus"]: {
      boxShadow: "unset",
    },
  },
  lime: {
    backgroundColor: "$colors$lime600",
    ["&:hover"]: {
      backgroundColor: "$colors$lime700",
    },
    ["&:focus"]: {
      boxShadow: "$colors$lime400 0px 0px 0px 3px",
    },
  },
  magenta: {
    backgroundColor: "$colors$magenta600",
    ["&:hover"]: {
      backgroundColor: "$colors$magenta700",
    },
    ["&:focus"]: {
      boxShadow: "$colors$magenta400 0px 0px 0px 3px",
    },
  },
  limeLight: {
    color: "$colors$lime700",
    backgroundColor: "$colors$lime100",
    ["&:hover"]: {
      backgroundColor: "$colors$lime200",
    },
    ["&:focus"]: {
      boxShadow: "$colors$lime400 0px 0px 0px 3px",
    },
  },
  limeGhost: {
    color: "$colors$lime600",
    backgroundColor: "white",
    border: "1px solid $colors$lime600",
    fontWeight: 500,

    ["&:hover"]: {
      backgroundColor: "$colors$gray50",
    },
    ["&:focus"]: {
      boxShadow: "$colors$lime400 0px 0px 0px 3px",
    },
  },
  dark: {
    color: "White",
    backgroundColor: "$colors$gray800",
    ["&:hover"]: {
      backgroundColor: "$colors$gray700",
    },
    ["&:focus"]: {
      boxShadow: "$colors$gray600 0px 0px 0px 3px",
    },
  },
  ocean: {
    backgroundColor: "$colors$ocean600",
    ["&:hover"]: {
      backgroundColor: "$colors$ocean700",
    },
    ["&:focus"]: {
      boxShadow: "$colors$ocean100 0px 0px 0px 3px",
    },
  },
  danger: {
    backgroundColor: "$colors$red600",
    ["&:hover"]: {
      backgroundColor: "$colors$red700",
    },
    ["&:focus"]: {
      boxShadow: "$colors$red100 0px 0px 0px 3px",
    },
  },
};

export const Button = styled("button", {
  color: "White",
  fontFamily: "$inter",
  backgroundColor: "$teal600",
  py: "$space$2",
  px: "$space$3",
  br: "$radii$3",
  cursor: "pointer",
  fontSize: "$2",
  lineHeight: "$2",
  fontWeight: "$2",
  outline: "none",
  whiteSpace: "nowrap",
  display: "flex",
  justifyContent: "center",
  border: "unset",
  alignItems: "center",
  ["&:disabled"]: {
    cursor: "default",
    backgroundColor: "$gray100",
    color: "$gray500",
    ["&:hover"]: {
      backgroundColor: "$gray100",
      color: "$gray500",
    },
  },
  variants: {
    size: {
      xsmall: {
        fontSize: "$2",
        lineHeight: "$2",
        fontWeight: "$2",
        maxHeight: "32px",
        maxWidth: "32px",
      },
      small: {
        fontSize: "$2",
        lineHeight: "$2",
        fontWeight: "$2",
        maxHeight: "32px",
      },
      medium: {
        fontSize: "$2",
        lineHeight: "$3",
        fontWeight: "$3",
        py: "$space$3",
        px: "$space$3",
        maxHeight: "40px",
      },
      large: {
        fontSize: "$4",
        lineHeight: "$3",
        fontWeight: "$3",
        py: "$space$3",
        px: "$space$3",
        maxHeight: "48px",
      },
    },
    variant: variantColorProps,
    paddings: {
      noPaddngs: {
        py: "0px",
        px: "0px",
      },
      smallPaddings: {
        py: "$space$1",
        px: "$space$1",
      },
      doublePaddings: {
        py: "$space$2",
        px: "$space$2",
      },
    },
    open: {
      true: {
        backgroundColor: "white",
        boxShadow: "$colors$teal400 0px 0px 0px 3px",
      },
    },
    shape: {
      rectangular: {},
      square: {
        py: "$space$3",
        px: "$space$3",
      },
      circle: {
        py: "$space$2",
        px: "$space$2",
        borderRadius: "$radii$full",
      },
      fixedSquare: {
        height: "32px",
        width: "32px",
        maxHeight: "32px",
        maxWidth: "32px",
        padding: "0px 0px",
      },
      fixedSquareLarge: {
        height: "40px",
        width: "40px",
        maxHeight: "40px",
        maxWidth: "40px",
        padding: "0px 0px",
      },
    },
    ring: {
      teal: {
        ["&:focus"]: {
          boxShadow: "$colors$teal100 0px 0px 0px 3px",
        },
      },
    },
  },
  defaultVariants: {
    size: "small",
    variant: "primary",
    shape: "rectangular",
  },
  compoundVariants: [
    {
      open: true,
      variant: "textOnly",
      css: {
        boxShadow: "none",
      },
    },
    {
      open: true,
      variant: "textOnlyDark",
      css: {
        boxShadow: "none",
      },
    },
  ],
});
